"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defer2 = _interopRequireDefault(require("q/js/lib/defer"));

var _default = {
  create: function create() {
    var _defer = (0, _defer2.default)();

    var _data = null;
    var container = {
      set: function set(data) {
        _defer.resolve(data);

        _data = data;
        return _data;
      },
      get: function get() {
        return _data;
      },
      then: function then() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _defer.promise.then(args);
      }
    };
    return {
      getContainer: function getContainer() {
        return container;
      },
      setContainer: function setContainer(newContainer) {
        if (typeof newContainer.get !== 'function') {
          throw new Error('container must contain a get function');
        }

        if (typeof newContainer.set !== 'function') {
          throw new Error('container must contain a set function');
        }

        if (typeof newContainer.then !== 'function') {
          throw new Error('container must contain a then function');
        }

        container = newContainer;
      },
      get: function get() {
        return this.getContainer().get();
      },
      set: function set(data) {
        return this.getContainer().set(data);
      },
      then: function then(args) {
        return this.getContainer().then(args);
      }
    };
  }
};
exports.default = _default;
module.exports = exports.default;